(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ffl-modular-product-customizer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ffl-modular-customizer')) customElements.define('ffl-modular-customizer', class extends HTMLElement {
    connectedCallback(){ const form=document.querySelector('product-form form[action*="/cart/add"]'); if(form)this.querySelectorAll('input,select,textarea').forEach(f=>f.setAttribute('form',form.id)); this.querySelectorAll('[data-progress-target]').forEach(b=>b.addEventListener('click',()=>this.querySelector('#FFLBlock-'+CSS.escape(b.dataset.progressTarget))?.scrollIntoView({behavior:'smooth',block:'start'}))); this.querySelectorAll('[data-subject-group]').forEach(g=>{const s=g.querySelector('[data-subject-count]'),pricing=g.querySelector('[data-photo-pricing]'),feeQuantity=g.querySelector('[data-extra-photo-quantity]');const update=()=>{g.querySelectorAll('[data-subject-card]').forEach(c=>this.state(c,+c.dataset.subjectCard<=+s.value));const included=+(pricing?.dataset.includedCount||2),extra=Math.max(0,+s.value-included);if(feeQuantity)feeQuantity.value=extra;if(pricing){const message=extra?pricing.dataset.feeText.replace('[count]',extra):pricing.dataset.includedText;pricing.querySelector('[data-photo-pricing-message]').textContent=message}this.updateProgress()};s?.addEventListener('change',update);update()}); this.querySelectorAll('[data-text-group]').forEach(g=>{const t=g.querySelector('[data-text-toggle]'),p=g.querySelector('[data-text-panel]'),c=g.querySelector('[data-text-count]');const rows=()=>{g.querySelectorAll('[data-text-row]').forEach(r=>this.state(r,+r.dataset.textRow<=+(c?.value||1)));this.updateProgress()};const panel=()=>{this.state(p,!!t?.checked);if(t?.checked)rows();this.updateProgress()};t?.addEventListener('change',panel);c?.addEventListener('change',rows);panel()});this.querySelectorAll('[data-lettering-group]').forEach(g=>{const toggle=g.querySelector('[data-handwriting-toggle]'),panel=g.querySelector('[data-handwriting-panel]');if(!toggle||!panel)return;const update=()=>{this.state(panel,toggle.checked);this.updateProgress()};toggle.addEventListener('change',update);update()});this.querySelectorAll('[data-proof-group]').forEach(g=>{const toggle=g.querySelector('[data-proof-toggle]'),panel=g.querySelector('[data-proof-email]'),property=g.querySelector('[data-proof-property]');const update=()=>{this.state(panel,!!toggle.checked);property.value=toggle.checked?'Yes':'No';this.updateProgress()};toggle.addEventListener('change',update);update()});this.querySelectorAll('[data-file-input]').forEach(i=>i.addEventListener('change',()=>{const f=i.files?.[0],upload=i.closest('[data-file-upload]');if(!f||!upload)return;const p=upload.querySelector('[data-file-preview]');p.textContent='Aa';if(f.type.startsWith('image/')){p.innerHTML='';const img=document.createElement('img');img.alt='';img.src=URL.createObjectURL(f);p.appendChild(img)}upload.querySelector('[data-file-label]').textContent=f.name;this.updateProgress()}));this.querySelectorAll('[data-visual-carousel]').forEach(c=>this.visualCarousel(c));this.querySelectorAll('[data-custom-dropdown]').forEach(d=>this.customDropdown(d));this.imagePreview();this.addEventListener('input',()=>this.updateProgress());this.addEventListener('change',()=>this.updateProgress());const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)this.querySelectorAll('[data-progress-item]').forEach(i=>i.classList.toggle('is-current',i.dataset.progressItem===e.target.dataset.customizerStep))}),{rootMargin:'-20% 0px -65% 0px'});this.querySelectorAll('[data-customizer-step]').forEach(s=>observer.observe(s));this.updateProgress()}
    visualCarousel(carousel){const track=carousel.querySelector('[data-visual-options]'),cards=[...track.querySelectorAll(':scope > label')],previous=carousel.querySelector('[data-visual-prev]'),next=carousel.querySelector('[data-visual-next]'),current=carousel.querySelector('[data-visual-current]');if(!cards.length)return;let frame;const activeIndex=()=>cards.reduce((best,card,index)=>{const distance=Math.abs(card.offsetLeft-track.scrollLeft);return distance<best.distance?{index,distance}:best},{index:0,distance:Infinity}).index;const update=()=>{const index=activeIndex();if(current)current.textContent=index+1;if(previous)previous.disabled=index===0;if(next)next.disabled=index===cards.length-1};const move=direction=>{const target=Math.max(0,Math.min(cards.length-1,activeIndex()+direction));track.scrollTo({left:cards[target].offsetLeft,behavior:'smooth'})};previous?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update)},{passive:true});cards.forEach(card=>card.addEventListener('click',()=>track.scrollTo({left:card.offsetLeft,behavior:'smooth'})));new ResizeObserver(update).observe(track);update()}
    customDropdown(dropdown){const value=dropdown.querySelector('[data-dropdown-value]');dropdown.querySelectorAll('input[type="radio"]').forEach(input=>{input.addEventListener('change',()=>{value.textContent=input.value;dropdown.open=false});input.addEventListener('invalid',()=>{dropdown.open=true})})}
    imagePreview(){const dialog=this.querySelector('[data-image-preview-dialog]'),target=dialog?.querySelector('[data-image-preview-target]'),caption=dialog?.querySelector('[data-image-preview-caption]');if(!dialog||!target||!caption)return;this.querySelectorAll('[data-image-preview]').forEach(button=>button.addEventListener('click',()=>{target.src=button.dataset.imageSrc;target.alt=button.dataset.imageAlt;caption.textContent=button.dataset.imageAlt;dialog.showModal()}));dialog.querySelector('[data-image-preview-close]')?.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()})}
    state(el,on){if(!el)return;el.hidden=!on;el.querySelectorAll('input,select,textarea').forEach(f=>f.disabled=!on)}
    updateProgress(){const items=[...this.querySelectorAll('[data-progress-item]')];this.querySelectorAll('[data-customizer-step]').forEach(step=>{const required=[...step.querySelectorAll('[required]:not(:disabled)')];const complete=required.every(field=>field.checkValidity());const item=this.querySelector('[data-progress-item="'+step.dataset.customizerStep+'"]');item?.classList.toggle('is-complete',complete);const number=item?.querySelector('[data-progress-number]');if(number)number.textContent=complete?'✓':items.indexOf(item)+1})}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ffl-product-creative-paths"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ffl-creative-paths')) customElements.define('ffl-creative-paths', class extends HTMLElement {
    connectedCallback(){
      this.form=document.querySelector('product-form form[action*="/cart/add"]');
      if(this.form)this.querySelectorAll('input').forEach(input=>input.setAttribute('form',this.form.id));
      this.designs=[...this.querySelectorAll('[data-path-design]')];
      this.styles=[...this.querySelectorAll('[data-path-style]')];
      this.continue=this.querySelector('[data-path-continue]');
      this.status=this.querySelector('[data-path-status]');
      const params=new URLSearchParams(location.search);
      this.selectFromParam(this.designs,params.get(this.dataset.designParam));
      this.updateStyles(false);
      this.selectFromParam(this.styles,params.get(this.dataset.styleParam));
      this.designs.forEach(input=>input.addEventListener('change',()=>this.updateStyles(true)));
      this.styles.forEach(input=>input.addEventListener('change',()=>this.update(false)));
      if(this.form)this.form.addEventListener('submit',event=>{
        const ready=this.designs.some(input=>input.checked)&&this.styles.some(input=>input.checked&&!input.disabled);
        if(!ready){event.preventDefault();this.scrollIntoView({behavior:'smooth',block:'start'});this.status.textContent=this.dataset.incompleteMessage||'Choose a design and art style before adding to cart.'}
      });
      this.update(false);
    }
    selectFromParam(inputs,value){if(!value)return;const input=inputs.find(item=>item.dataset.handle===value);if(input)input.checked=true}
    updateStyles(clearStyle){
      const design=this.designs.find(input=>input.checked);
      this.querySelectorAll('[data-style-card]').forEach(card=>{
        const compatible=card.dataset.compatibleDesigns.split(',').filter(Boolean);
        const visible=!design||!compatible.length||compatible.includes(design.dataset.handle);
        card.hidden=!visible;
        card.querySelector('input').disabled=!visible;
        if(!visible)card.querySelector('input').checked=false;
      });
      if(clearStyle)this.styles.forEach(input=>input.checked=false);
      this.update(false);
    }
    update(){
      const design=this.designs.find(input=>input.checked);
      const style=this.styles.find(input=>input.checked&&!input.disabled);
      this.querySelector('[data-selected-design]').textContent=design?.value||this.dataset.designPlaceholder;
      this.querySelector('[data-selected-style]').textContent=style?.value||this.dataset.stylePlaceholder;
      this.querySelector('[data-style-workflow]').value=style?.dataset.workflow||'';
      const ready=Boolean(design&&style);
      this.continue.setAttribute('aria-disabled',String(!ready));
      this.status.dataset.ready=String(ready);
      this.status.textContent=ready?this.dataset.readyMessage:this.dataset.incompleteMessage;
      const url=new URL(location.href);
      design?url.searchParams.set(this.dataset.designParam,design.dataset.handle):url.searchParams.delete(this.dataset.designParam);
      style?url.searchParams.set(this.dataset.styleParam,style.dataset.handle):url.searchParams.delete(this.dataset.styleParam);
      history.replaceState({},'',url);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ffl-product-customizer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ffl-product-customizer')) {
    customElements.define('ffl-product-customizer', class extends HTMLElement {
      connectedCallback() {
        this.form = document.querySelector('product-info product-form form[data-type="add-to-cart-form"]');
        if (this.form?.id) this.querySelectorAll('input, select, textarea').forEach((field) => field.setAttribute('form', this.form.id));
        this.subjectCount = this.querySelector('[data-subject-count]');
        this.textToggle = this.querySelector('[data-text-toggle]');
        this.textCount = this.querySelector('[data-text-count]');
        this.subjectCount?.addEventListener('change', () => this.updateSubjects());
        this.textToggle?.addEventListener('change', () => this.updateTextPanel());
        this.textCount?.addEventListener('change', () => this.updateTextRows());
        this.querySelectorAll('[data-file-input]').forEach((input) => input.addEventListener('change', () => this.updateFile(input)));
        this.updateSubjects();
        this.updateTextPanel();
      }
      setGroupState(container, active) {
        container.hidden = !active;
        container.querySelectorAll('input, select, textarea').forEach((field) => field.disabled = !active);
      }
      updateSubjects() {
        const count = Number(this.subjectCount?.value || 1);
        this.querySelectorAll('[data-subject-card]').forEach((card) => this.setGroupState(card, Number(card.dataset.subjectCard) <= count));
      }
      updateTextPanel() {
        const panel = this.querySelector('[data-text-panel]');
        if (!panel) return;
        this.setGroupState(panel, Boolean(this.textToggle?.checked));
        if (this.textToggle?.checked) this.updateTextRows();
      }
      updateTextRows() {
        const count = Number(this.textCount?.value || 1);
        this.querySelectorAll('[data-text-row]').forEach((row) => this.setGroupState(row, Number(row.dataset.textRow) <= count));
      }
      updateFile(input) {
        const card = input.closest('[data-subject-card]');
        const file = input.files?.[0];
        if (!card || !file) return;
        const preview = card.querySelector('[data-file-preview]');
        const label = card.querySelector('[data-file-label]');
        preview.innerHTML = '';
        const image = document.createElement('img');
        image.alt = '';
        image.src = URL.createObjectURL(file);
        preview.appendChild(image);
        label.textContent = file.name;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ffl-story-directory"] && !Shopify.designMode) return;
  try {
    
  const initializeFflCarousels = (root = document) => {
    root.querySelectorAll('[data-ffl-carousel]:not([data-ffl-ready])').forEach((carousel) => {
      carousel.dataset.fflReady = 'true';
      const slides = Array.from(carousel.querySelectorAll('[data-ffl-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-ffl-dot]'));
      const previous = carousel.querySelector('[data-ffl-previous]');
      const next = carousel.querySelector('[data-ffl-next]');
      const interval = Number(carousel.dataset.interval) || 5000;
      const shouldAutoplay = carousel.dataset.autoplay === 'true';
      let activeIndex = 0;
      let timer;

      const showSlide = (newIndex) => {
        activeIndex = (newIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (shouldAutoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
        }
      };

      previous.addEventListener('click', () => { showSlide(activeIndex - 1); start(); });
      next.addEventListener('click', () => { showSlide(activeIndex + 1); start(); });
      dots.forEach((dot, index) => dot.addEventListener('click', () => { showSlide(index); start(); }));
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', (event) => { if (!carousel.contains(event.relatedTarget)) start(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });
      start();
    });
  };

  initializeFflCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeFflCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
